import { lazy } from 'react';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';

const UsersList = lazy(() => import('./screens/UsersList'));
const UserPermissions = lazy(() => import('./screens/UserPermissions'));
const InviteUsers = lazy(() => import('./screens/InviteUsers'));
const AcceptInvitation = lazy(() => import('./screens/AcceptInvitation'));
const AcceptInvitationV2 = lazy(() => import('./screens/AcceptInvitationV2'));
const UserForm = lazy(() => import('./screens/UserForm'));
const UserNotifications = lazy(() => import('./screens/Notifications/SelfUserNotificationsRedirect'));
const UserInfo = lazy(() => import('./screens/UserInfo'));
const UserImportWizard = lazy(() => import('@src/packages/userImports/screens/UserImportWizard'));

const routesRoutes = [
  {
    component: UsersList,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USERS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: UserPermissions,
    exact: true,
    path: PATHS.USER_PERMISSIONS,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USERS.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: InviteUsers,
    path: PATHS.USERS_INVITE,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.INVITATIONS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: AcceptInvitation,
    path: PATHS.ACCEPT_INVITATION,
    onOrgChangeRedirectTo: '',
  },
  {
    component: AcceptInvitationV2,
    path: PATHS.ACCEPT_INVITATION_V2,
    onOrgChangeRedirectTo: '',
  },
  {
    component: UserForm,
    path: PATHS.CREATE_USER,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USERS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: UserImportWizard,
    path: PATHS.IMPORT_USERS,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USER_IMPORTS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: UserForm,
    path: PATHS.EDIT_USER,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USERS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: UserInfo,
    path: PATHS.USER_INFO,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.USERS.GET,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: UserNotifications,
    path: PATHS.USER_NOTIFICATIONS,
    onOrgChangeRedirectTo: '',
  },
];

export default routesRoutes;
